import Tracker from "@openreplay/tracker"
import { useEffect } from "react"
import { useQueryCustomer } from "../../hooks/customer/use-query-customer"

export const tracker = new Tracker({
    projectKey: process.env.OPENREPLAY_KEY,
    ingestPoint: process.env.OPENREPLAY_URL,
    obscureTextEmails: false,
    obscureInputEmails: false,
    captureIFrames: false,
})

const OpenReplay = () => {
    useEffect(() => {
        tracker.start()
    }, [])

    const { data: customerData } = useQueryCustomer(undefined, { background: true })

    useEffect(() => {
        if (!customerData?.address.email) return

        tracker.setUserID(customerData.address.email)
    }, [customerData])

    return null
}

export default OpenReplay
